import axios from 'axios';

export const BASE_SERVICE_CHAT_USER_URL = `${process.env.REACT_APP_BASE_URL}/users?format=service_chat`;

export const SERVICE_CHAT_CHANNEL = 'service-chat-channel';
export const SERVICE_CHAT_MESSAGE_SENT = 'SERVICE_CHAT_MESSAGE_SENT';
export const SERVICE_CHAT_STORAGE_KEY = 'service-chat-message-sent';
export const SERVICE_CHAT_TAB_ID = `${Date.now()}-${Math.random().toString(36).slice(2)}`;

export const broadcastServiceChatMessageSent = (serviceId, channel) => {
  if (!serviceId) return;

  const payload = {
    type: SERVICE_CHAT_MESSAGE_SENT,
    serviceId,
    senderId: SERVICE_CHAT_TAB_ID,
    ts: Date.now()
  };

  if (channel) {
    channel.postMessage(payload);
  } else if (typeof window.BroadcastChannel === 'function') {
    const oneShotChannel = new window.BroadcastChannel(SERVICE_CHAT_CHANNEL);
    oneShotChannel.postMessage(payload);
    oneShotChannel.close();
  }

  // storage events fire only in other tabs — reliable cross-tab fallback
  try {
    localStorage.setItem(SERVICE_CHAT_STORAGE_KEY, JSON.stringify(payload));
  } catch (_) {
    // ignore quota / private mode errors
  }
};

export const getUserInfoFromIDs = async (ids) => {
  if (!Array.isArray(ids) || ids.length === 0) {
    return Promise.resolve([]);
  }

  return axios
    .get(`${BASE_SERVICE_CHAT_USER_URL}&ids=${ids.join(',')}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('idToken')}`
      }
    })
    .then((res) => res.data);
};
